import React, { PureComponent } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { safeHtml } from "../../utils/htmlEscape";

class PageHeader extends PureComponent {
  render() {
    const { title, subtitle, tooltip } = this.props;

    return (
      <div className="col-12 mt-2 pl-3">
        <header className="widget__header">
          <h5 className="widget__title">
            {title}{" "}
            {tooltip && (
              <>
                <span
                  className="with-tooltip"
                  data-tooltip-id="main-tooltip"
                  data-tooltip-html={tooltip}
                ></span>
                <ReactTooltip
                  id="main-tooltip"
                  className="title-tooltip-header"
                  positionStrategy="fixed"
                />
              </>
            )}
          </h5>
        </header>

        {subtitle && (
          <div className="row">
            <div className="col">
              <small
                className="text-gray"
                dangerouslySetInnerHTML={safeHtml(subtitle)}
              ></small>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PageHeader;
